import { sharedCalculatorNav, sharedCalculatorTranslations } from './calculatorShared';

export const ky = {
  // Purchased Cars (Win Cars) view tabs
  winCarsView: {
    ourDealers: 'Биздин Дилерлер',
    allAuctionWins: 'Бардык Аукцион Жеңиштери',
    ourDealersHint: 'Тек биздин катталган дилерлерге сатып алынган же тагайындалган унаалар.',
    allAuctionWinsHint: 'Аукцион агымындагы бардык унаалар (маалыматтык).',
  },

  // Navigation
  nav: {
    dashboard: 'Башкы',
    branches: 'Филиалдар',
    managers: 'Менеджерлер',
    dealers: 'Дилерлер',
    subdealers: 'Субдилерлер',
    winCars: 'Сатып Алынган Унаалар',
    accounts: 'Эсептер',
    auctionFees: 'Аукцион Төлөмдөрү',
    deliveryCost: 'Жеткирүү Наркы',
    statistics: 'Ставкалар',
    watchlist: 'Көзөмөлдөө тизмеси',
    tools: 'Куралдар',
    settings: 'Жөндөөлөр',
    ...sharedCalculatorNav,
  },

  // Common
  common: {
    add: 'Кошуу',
    edit: 'Өзгөртүү',
    delete: 'Өчүрүү',
    save: 'Сактоо',
    cancel: 'Жокко чыгаруу',
    create: 'Түзүү',
    update: 'Жаңыртуу',
    back: 'Артка',
    refresh: 'Жаңыртуу',
    search: 'Издөө',
    actions: 'Аракеттер',
    status: 'Статус',
    contact: 'Байланыш',
    email: 'Эл. почта',
    phone: 'Телефон',
    name: 'Аты',
    username: 'Колдонуучунун аты',
    password: 'Сыр сөз',
    confirmPassword: 'Сыр сөздү тастыктоо',
    loading: 'Жүктөлүүдө...',
    noDataFound: 'Маалымат табылган жок',
    total: 'Жалпы',
    active: 'Активдүү',
    inactive: 'Активдүү эмес',
    all: 'Баардык',
    filters: 'Фильтрлер',
  },

  watchlist: { notFound: 'табылган жок', remove: 'Тизмеден өчүрүү' },

  // Branches
  branches: {
    title: 'Филиалдарды башкаруу',
    addBranch: 'Филиал кошуу',
    editBranch: 'Филиалды өзгөртүү',
    createBranch: 'Жаңы филиал түзүү',
    branchName: 'Филиалдын аталышы',
    branchCode: 'Филиалдын коду',
    location: 'Жайгашкан жери',
    country: 'Өлкө',
    city: 'Шаар',
    address: 'Дарек',
    totalBranches: 'Жалпы филиалдар',
    activeBranches: 'Активдүү филиалдар',
    totalManagers: 'Жалпы менеджерлер',
    totalDealers: 'Жалпы дилерлер',
    totalSubdealers: 'Жалпы субдилерлер',
    created: 'Түзүлгөн',
    backToBranches: 'Филиалдарга кайтуу',
    noBranchesFound: 'Филиалдар табылган жок',
    deleteBranchConfirm: 'Филиалды өчүргүңүз келеби',
  },

  // Managers
  managers: {
    title: 'Менеджерлерди башкаруу',
    addManager: 'Менеджер кошуу',
    editManager: 'Менеджерди өзгөртүү',
    createManager: 'Жаңы менеджер түзүү',
    firstName: 'Аты',
    lastName: 'Фамилиясы',
    assignToBranch: 'Филиалга дайындоо',
    totalManagers: 'Жалпы менеджерлер',
    georgiaManagers: 'Грузия филиалы',
    dubaiManagers: 'Дубай филиалы',
    armeniaManagers: 'Армения филиалы',
    activeBids: 'Активдүү ставкалар',
    monthlyRevenue: 'Айлык кирешең',
    wonAuctions: 'Утулган аукциондор',
    backToManagers: 'Менеджерлерге кайтуу',
    noManagersFound: 'Менеджерлер табылган жок',
    deleteManagerConfirm: 'Менеджерди өчүргүңүз келеби',
  },

  // Dealers
  dealers: {
    title: 'Дилерлерди башкаруу',
    addDealer: 'Дилер кошуу',
    editDealer: 'Дилерди өзгөртүү',
    createDealer: 'Жаңы дилер түзүү',
    totalDealers: 'Жалпы дилерлер',
    georgiaDealers: 'Грузиянын дилерлери',
    dubaiDealers: 'Дубайдын дилерлери',
    armeniaDealers: 'Армениянын дилерлери',
    assignToManager: 'Менеджерге дайындоо',
    totalSubdealers: 'Жалпы субдилерлер',
    totalSpent: 'Жалпы коротулган',
    successRate: 'Ийгилик пайызы',
    myBids: 'Менин ставкаларым жана машиналарым',
    subdealersBids: 'Субдилерлердин ставкалары жана машиналары',
    allBids: 'Бардык ставкалар жана машиналар',
    myActiveBids: 'Менин активдүү ставкаларым',
    subdealersActiveBids: 'Субдилерлердин активдүү ставкалары',
    totalCarsWon: 'Жалпы утулган машиналар',
    backToDealers: 'Дилерлерге кайтуу',
    noDealersFound: 'Дилерлер табылган жок',
    deleteDealerConfirm: 'Дилерди өчүргүңүз келеби',
    deleteDealer: 'Delete Dealer',
    loadingList: 'Loading dealers...',
    filtersActiveSuffix: 'filter(s) active',
    quickSearchPlaceholder: 'Search by Name, Username, Email, or Phone...',
    ctrlFHint: 'Ctrl+F / ⌘F',
    advancedFilters: 'Advanced Filters',
    branchFilterPh: 'Branch',
    managerFilterPh: 'Manager',
    allBranches: 'All Branches',
    allManagers: 'All Managers',
    clearFilters: 'Clear Filters',
    pageTotalShowing: 'Showing',
    pageTotalOf: 'of',
    pageTotalLabel: 'total',
    auctionAccountsTitle: 'Auction Accounts',
    auctionAccountsRequired:
      'Please select at least one primary auction account (Copart, IAAI, Manheim, or ACV).',
    passwordLeaveBlank: 'Password (leave empty to keep current)',
    passwordLabel: 'Password',
    phoneLabel: 'Phone',
    selectBranch: 'Select branch',
    selectManager: 'Select manager',
    toggleOn: 'On',
    toggleOff: 'Off',
    phFirst: 'e.g., Nikoloz',
    phLast: 'e.g., Baratashvili',
    phUsername: 'e.g., dealer.ge1',
    phEmail: 'dealer@bidmanager.com',
    phPhone: '+995 555 777 777',
    accountAmPlaceholder: '🇬🇪 GE Account',
    accountUsOptional: '🇺🇸 US Account (Optional)',
    noneOption: 'None',
    unknownBranch: 'Unknown Branch',
    bidLimitLabel: 'Bid Limit',
    activeBidsAmountLabel: 'Active Bids Amount',
    activeBidsSumLimitLabel: 'Active Bids Sum Limit',
    purchasedCarsLimitLabel: 'Purchased Cars Limit',
    lotsEventSettingLabel: 'Lots Event Setting',
    purchasedLotsSettingLabel: 'Purchased Lots Setting',
    showCalculatorWidget: 'Show Calculator Widget',
    showHelperTool: 'Show Helper Tool',
    showDiscountRow: 'Show Discount Row',
    fixedDiscountAmount: 'Fixed Discount Amount ($)',
    fixedDiscountHelp: 'Fixed discount amount in USD',
    iaaiCanadaTitle: 'IAAI (Canada)',
    calculatorSettingsSection: 'Calculator Settings',
    auctionLimitsSection: 'Auction & limits',
    visibilityHide: 'Hide',
    visibilityShow: 'Show',
    visibilityPartlyShow: 'Partly Show',
    visibilityWinningLots: 'Winning Lots',
    colDealer: 'Dealer',
    colBranch: 'Branch',
    colManager: 'Manager',
    colContact: 'Contact',
    colSubdealers: 'Subdealers',
    colActiveBids: 'Active Bids',
    colTotalSpent: 'Total Spent',
    colCreatedBy: 'Created By',
    colActions: 'Actions',
    tooltips: {
      bidLimit: 'Бир лотко максималдуу ставка лимити',
      activeBidsLimit: 'Колдонуучу канча ставка койгон. Жаңы колдонуучулар үчүн 0-ге орнотуңуз',
      activeBidsSumLimit: 'Колдонуучу бардык лотторго койо алаткан максималдуу жалпы USD суммасы',
      purchasedCarsLimit: 'Колдонуучу сатып ала алаткан максималдуу машина саны',
      packageSlug: 'Колдонуучу пакетинин түрү',
      lotsEventSetting: '"Менин ставкаларым" жана "/dashboard" барактарына кол жеткизүүнү башкарат',
      purchasedLotsSetting: 'Төлөм карызын жана төлөмдөр тарыхы барактарын көрүүгө кол жеткизүүнү башкарат',
    },
  },

  // Subdealers
  subdealers: {
    title: 'Субдилерлерди башкаруу',
    addSubdealer: 'Субдилер кошуу',
    editSubdealer: 'Субдилерди өзгөртүү',
    createSubdealer: 'Жаңы субдилер түзүү',
    assignToDealer: 'Дилерге дайындоо',
    dealer: 'Дилер',
    branch: 'Филиал',
    manager: 'Менеджер',
    totalSpent: 'Жалпы коротулган',
    wonAuctions: 'Утулган аукциондор',
    activeBids: 'Активдүү ставкалар',
    backToSubdealers: 'Субдилерлерге кайтуу',
    noSubdealersFound: 'Субдилерлер табылган жок',
    deleteSubdealerConfirm: 'Субдилерди өчүргүңүз келеби',
    tooltips: {
      bidLimit: 'Бир лотко максималдуу ставка лимити',
      activeBidsLimit: 'Колдонуучу канча ставка койгон. Жаңы колдонуучулар үчүн 0-ге орнотуңуз',
      activeBidsSumLimit: 'Колдонуучу бардык лотторго койо алаткан максималдуу жалпы USD суммасы',
      purchasedCarsLimit: 'Колдонуучу сатып ала алаткан максималдуу машина саны',
      packageSlug: 'Колдонуучу пакетинин түрү',
      lotsEventSetting: '"Менин ставкаларым" жана "/dashboard" барактарына кол жеткизүүнү башкарат',
      purchasedLotsSetting: 'Төлөм карызын жана төлөмдөр тарыхы барактарын көрүүгө кол жеткизүүнү башкарат',
    },
  },

  // Bids & Cars
  bids: {
    lotNumber: 'Лот номери',
    vin: 'VIN',
    vehicle: 'Машина',
    bidAmount: 'Ставка суммасы',
    status: 'Статус',
    bidder: 'Ставка коюучу',
    subdealer: 'Субдилер',
    won: 'УТУЛДУ',
    active: 'АКТИВДҮҮ',
    lost: 'УТУЛБАДЫ',
    totalBids: 'Жалпы ставкалар',
    bidsAndCars: 'Ставкалар жана машиналар',
    noBidsFound: 'Ставкалар табылган жок',
  },

  layout: {
    footerBrand: 'Bidmanager системасы',
  },

  // Auth
  auth: {
    login: 'Кирүү',
    logout: 'Чыгуу',
    welcomeBack: 'Кош келиңиз',
    signIn: 'Кирүү',
    profile: 'Профиль',
    loginSubtitle: 'Унаа аукционун башкаруу системасы',
    usernamePlaceholder: 'Колдонуучунун аты',
    passwordPlaceholder: 'Сырсөз',
    signingIn: 'Кирүүдө...',
    loginFailed: 'Кирүү ишке ашкан жок. Маалыматтарды текшериңиз.',
    connectionError: 'Байланыш катасы. Интернетти текшерип кайра аракет кылыңыз.',
    forgotPasswordQuestion: 'Сырсөзүңүздү унуттуңузбу?',
    forgotPasswordTitle: 'Сырсөздү калыбына келтирүү',
    forgotPasswordHint:
      'Сырсөздү калыбына келтирүү катчысы үчүн электрондук почтаңызды же колдонуучунун атын киргизиңиз.',
    resetByEmail: 'Э-почта менен',
    resetByUsername: 'Колдонуучунун аты менен',
    emailPlaceholder: 'Э-почтаңызды киргизиңиз',
    forgotUsernamePlaceholder: 'Колдонуучунун атын киргизиңиз',
    sending: 'Жөнөтүлүүдө...',
    sendResetEmail: 'Калыбына келтирүү катчысын жөнөтүү',
    checkEmailTitle: 'Э-почтаңызды текшериңиз',
    checkEmailBody:
      'Эгер мындай аккаунт бар болсо, сырсөздү калыбына келтирүү катчысы жөнөтүлдү. Почта кутуңузду караңыз.',
    backToLogin: 'Кирүү бетине кайтуу',
    provideEmailOrUsername: 'Э-почта же колдонуучунун атын көрсөтүңүз',
    enterEmailAddress: 'Э-почта дарегин киргизиңиз',
    enterUsernameRequired: 'Колдонуучунун атын киргизиңиз',
    requestFailedLater: 'Сурам ишке ашкан жок. Кийин кайра аракет кылыңыз.',
  },

  // Stats
  stats: {
    statistics: 'Статистика',
    dashboard: 'Башкаруу панели',
  },

  // Dashboard
  dashboard: {
    systemAdminDashboard: 'Системанын администраторунун панели',
    branchManagerDashboard: 'Филиалдын менеджеринин панели',
    dealerDashboard: 'Дилердин панели',
    yourAuctionDashboard: 'Сиздин аукцион панелиңиз',
    welcomeToDashboard: 'Bidmanager панелине кош келиңиз',
    welcomeBack: 'Кош келиңиз',
    systemOverview: 'системанын',
    branchOverview: 'филиалдын',
    activityOverview: 'активдүүлүктүн',
    overview: 'көз карашы',
    hereIsYour: 'Бул сиздин',
    downloadApp: 'Колдонмону жүктөп алуу',
    downloadAppDesc: 'Аукциондорду башкаруу үчүн мобилдик колдонмону алыңыз',
    downloadNow: 'Азыр жүктөп алуу',
    yourManager: 'Сиздин менеджериңиз',
    yourManagerDesc: 'Жардам алуу үчүн менеджериңиз менен байланышыңыз',
    whatsapp: 'WhatsApp',
    viber: 'Viber',
    tarifPlan: 'Тариф планы',
    basic: 'Базалык',
    planLimits: '5 машина • $10,000 чек',
    upgradePlan: 'Планды жаңыртуу',
    quickOverview: 'Тез көз карашы',
    priceList: 'Баа тизмеси',
    oneActive: '1 Активдүү',
    twoOnline: '2 Онлайн',
    twoActive: '2 Активдүү',
    name: 'Аты',
    user: 'Колдонуучу',
    account: 'Эсеп',
    auction: 'Аукцион',
    activity: 'Активдүүлүк',
    action: 'Аракет',
    managePriceLists: 'Баа тизмелерин башкаруу',
    manageSubdealers: 'Субдилерлерди башкаруу',
    manageAccounts: 'Эсептерди башкаруу',
    online: 'Онлайн',
    systemMetrics: 'Система метрикасы',
    branchPerformance: 'Филиалдын натыйжалуулугу',
    yourActivity: 'Сиздин активдүүлүгүңүз',
    totalBranches: 'Жалпы филиалдар',
    activeBranchesWorldwide: 'Дүйнө жүзү боюнча активдүү филиалдар',
    branchManagers: 'Филиал менеджерлери',
    acrossAllBranches: 'Бардык филиалдарда',
    totalRevenue: 'Жалпы киреше',
    totalPlatformRevenue: 'Платформанын жалпы кирешеси',
    mySubdealers: 'Менин субдилерлерим',
    activeInYourBranch: 'Сиздин филиалыңызда активдүү',
    currentlyInProgress: 'Учурда иштеп жатат',
    byYourBranch: 'Сиздин филиалыңыз тарабынан',
    currentlyBidding: 'Учурда ставка коюуда',
    thisMonth: 'Бул айда',
    totalBidsPlaced: 'Жалпы коюлган ставкалар',
    totalWonAuctions: 'Жалпы жеңилген аукциондор',
  },

  // Form validation
  validation: {
    required: 'Бул талаа милдеттүү',
    invalidEmail: 'Туура эмес эл. почта дареги',
    passwordMismatch: 'Сыр сөздөр дал келбейт',
    minLength: 'Минималдуу узундугу',
    maxLength: 'Максималдуу узундугу',
  },

  // Notifications
  notifications: {
    createSuccess: 'Ийгиликтүү түзүлдү',
    updateSuccess: 'Ийгиликтүү жаңыртылды',
    deleteSuccess: 'Ийгиликтүү өчүрүлдү',
    error: 'Ката кетти',
  },

  ...sharedCalculatorTranslations,

  // Delivery Cost
  deliveryCost: {
    title: 'Жеткирүү наркын башкаруу',
    addNew: 'Жаңы жерди кошуу',
    editLocation: 'Жерди өзгөртүү',
    location: 'Жер',
    fee: 'Нарк',
    notes: 'Эскертмелер',
    auction: 'Аукцион',
    country: 'Өлкө',
    armenia: 'Армения',
    georgia: 'Грузия',
    auctionCopart: 'Copart',
    auctionIaai: 'IAAI',
    auctionManheim: 'Manheim',
    statsCopart: 'Copart:',
    statsIaai: 'IAAI:',
    statsManheim: 'Manheim:',
    totalLocations: 'Жалпы жерлер',
    searchLocation: 'Жерди издөө',
    searchPlaceholder: 'мисалы, Атланта, Хьюстон...',
    addNotes: 'Эскертмелерди кошуу...',
    notesPlaceholder: 'Бул жер жөнүндө кошумча эскертмелер...',
    confirmDelete: 'Өчүрүүнү ырастоо',
    confirmDeleteMessage: 'Бул жеткирүү наркын өчүргүңүз келгенине ишенесизби? Бул аракетти артка кайтаруу мүмкүн эмес.',
    createSuccess: 'Жеткирүү наркы ийгиликтүү түзүлдү',
    updateSuccess: 'Жеткирүү наркы ийгиликтүү жаңыртылды',
    deleteSuccess: 'Жеткирүү наркы ийгиликтүү өчүрүлдү',
    loadError: 'Жеткирүү нарктарын жүктөө ийгиликсиз болду',
    saveError: 'Жеткирүү наркын сактоо ийгиликсиз болду',
    deleteError: 'Жеткирүү наркын өчүрүү ийгиликсиз болду',
    validationError: 'Жер жана нарк милдеттүү',
  },
};

